module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "30vw",
      "value": _vm.value,
      "max-width": "30vw",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "headline ims-modal-header"
  }, [_vm._v("\n      Update Content for  "), _c('strong', [_vm._v(" @" + _vm._s(_vm.ighandle) + " ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "text": "",
      "color": "secondary",
      "aria-label": "Close update content dialog"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-combobox', {
    staticClass: "mr-2",
    attrs: {
      "items": _vm.pairedInfluencers,
      "item-text": "accountLabel",
      "item-value": "accountKey",
      "return-object": "",
      "loading": _vm.pairedInfluencersLoading,
      "hide-details": "auto",
      "label": "Handle",
      "prefix": "@",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.changePlatform
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item.displayHandle || item.instagramHandle) ? _c('span', [_vm._v("\n              " + _vm._s(item.displayHandle || item.instagramHandle) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(item) + "\n            ")])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center justify-space-between account-option"
        }, [_c('social-handle-view', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": !item.platform || item.platform === 'instagram',
            "isYoutube": item.platform === 'youtube',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.instagramHandle,
            "instagramHandle": item.instagramHandle,
            "youtubeHandle": item.instagramHandle,
            "facebookHandle": item.instagramHandle,
            "linkedinHandle": item.instagramHandle,
            "twitterHandle": item.twitterHandle || item.instagramHandle,
            "xiaohongshuHandle": item.instagramHandle,
            "isOthers": item.platform === 'others',
            "otherHandle": item.instagramHandle
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "caption grey--text ml-3"
        }, [_vm._v(_vm._s(_vm.getPlatformDisplayName(item.platform)))])], 1)]
      }
    }]),
    model: {
      value: (_vm.updateHandle),
      callback: function($$v) {
        _vm.updateHandle = $$v
      },
      expression: "updateHandle"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.platformTypes,
      "label": "Platform",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.updatePlatform),
      callback: function($$v) {
        _vm.updatePlatform = $$v
      },
      expression: "updatePlatform"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.targetCountries,
      "item-text": "name",
      "item-value": "name",
      "label": "Country",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  })], 1), _vm._v(" "), (_vm.isStory) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.storyInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Story Media URL"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData, "media_url", $$v)
      },
      expression: "storyInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Story Media URL"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData, "embed_url", $$v)
      },
      expression: "storyInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.storyInsightSubmittingData.live_date = _vm.parseDate(_vm.storyInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedDateFormatted),
            callback: function($$v) {
              _vm.computedDateFormatted = $$v
            },
            expression: "computedDateFormatted"
          }
        }, on))]
      }
    }], null, false, 3972542783),
    model: {
      value: (_vm.storyLiveCal),
      callback: function($$v) {
        _vm.storyLiveCal = $$v
      },
      expression: "storyLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.storyLiveCal = false
      }
    },
    model: {
      value: (_vm.storyInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData, "live_date", $$v)
      },
      expression: "storyInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog('story')
      }
    }
  }, [_vm._v("\n              Upload Stats with AI\n            ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.reach),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "reach", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "impressions", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Story Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.story_likes),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "story_likes", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.story_likes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Replies",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.replies),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "replies", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.replies"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Link Clicks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.link_clicks),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "link_clicks", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.link_clicks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sticker Taps",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.storyInsightSubmittingData.insights.sticker_taps),
      callback: function($$v) {
        _vm.$set(_vm.storyInsightSubmittingData.insights, "sticker_taps", _vm._n($$v))
      },
      expression: "storyInsightSubmittingData.insights.sticker_taps"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.storyInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isTikTok) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.postInsightSubmittingData.live_date = _vm.parseDate(_vm.postInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedTikTokDateFormatted),
            callback: function($$v) {
              _vm.computedTikTokDateFormatted = $$v
            },
            expression: "computedTikTokDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.tiktokLiveCal),
      callback: function($$v) {
        _vm.tiktokLiveCal = $$v
      },
      expression: "tiktokLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.tiktokLiveCal = false
      }
    },
    model: {
      value: (_vm.postInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "live_date", $$v)
      },
      expression: "postInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("TikTok Insights")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog('tiktok')
      }
    }
  }, [_vm._v("\n              Upload Stats with AI\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary",
      "disabled": _vm.isLoading || !_vm.getScrapeTargetLink()
    },
    on: {
      "click": function($event) {
        _vm.scrapComments(_vm.getScrapeTargetLink(), _vm.postInsightReportID)
      }
    }
  }, [_vm._v("\n              Extract Stats\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-13px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "hour", $$v)
      },
      expression: "totalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "minute", $$v)
      },
      expression: "totalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.totalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.totalPlayTime, "second", $$v)
      },
      expression: "totalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watches", $$v)
      },
      expression: "postInsightSubmittingData.inputtedInsights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "shares", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Favourites (Bookmarks)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Total Viewers (Reach)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Watched full video (%)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watchedFullVideo),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watchedFullVideo", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.watchedFullVideo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Photo Views",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.photo_views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "photo_views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.photo_views"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.postInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isYoutube) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.postInsightSubmittingData.live_date = _vm.parseDate(_vm.postInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedYoutubeDateFormatted),
            callback: function($$v) {
              _vm.computedYoutubeDateFormatted = $$v
            },
            expression: "computedYoutubeDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.youtubeLiveCal),
      callback: function($$v) {
        _vm.youtubeLiveCal = $$v
      },
      expression: "youtubeLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.youtubeLiveCal = false
      }
    },
    model: {
      value: (_vm.postInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "live_date", $$v)
      },
      expression: "postInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("Youtube Insights")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary",
      "disabled": _vm.isLoading || !_vm.getScrapeTargetLink()
    },
    on: {
      "click": function($event) {
        _vm.scrapComments(_vm.getScrapeTargetLink(), _vm.postInsightReportID)
      }
    }
  }, [_vm._v("\n              Extract Stats\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Outreach",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.outreach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "outreach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.outreach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Engagement Rate",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.engagement_rate),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "engagement_rate", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.engagement_rate"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Unique Viewers",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.unique_viewers),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "unique_viewers", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.unique_viewers"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watches", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.watches"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.postInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isXHS) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "media_url", $$v)
      },
      expression: "xhsPostInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "embed_url", $$v)
      },
      expression: "xhsPostInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.xhsLink) ? _c('v-text-field', {
    attrs: {
      "label": "XHS Link"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.xhsLink),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "xhsLink", $$v)
      },
      expression: "xhsPostInsightSubmittingData.xhsLink"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.xhsFullname) ? _c('v-text-field', {
    attrs: {
      "label": "Full name"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.xhsFullname),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "xhsFullname", $$v)
      },
      expression: "xhsPostInsightSubmittingData.xhsFullname"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.xhsPostInsightSubmittingData.xhsFollowers || _vm.xhsPostInsightSubmittingData.xhsFollowers === '0' || _vm.xhsPostInsightSubmittingData.xhsFollowers === 0) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.xhsFollowers),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "xhsFollowers", $$v)
      },
      expression: "xhsPostInsightSubmittingData.xhsFollowers"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.xhsPostInsightSubmittingData.live_date = _vm.parseDate(_vm.xhsPostInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedXHSDateFormatted),
            callback: function($$v) {
              _vm.computedXHSDateFormatted = $$v
            },
            expression: "computedXHSDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.xhsLiveCal),
      callback: function($$v) {
        _vm.xhsLiveCal = $$v
      },
      expression: "xhsLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.xhsLiveCal = false
      }
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData, "live_date", $$v)
      },
      expression: "xhsPostInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.watches),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "watches", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "bookmarks", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.xhsPostInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.xhsPostInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "xhsPostInsightSubmittingData.insights.shares"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.xhsPostInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isLemon) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "media_url", $$v)
      },
      expression: "lemonPostInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "embed_url", $$v)
      },
      expression: "lemonPostInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.lemonLink) ? _c('v-text-field', {
    attrs: {
      "label": "lemon Link"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.lemonLink),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "lemonLink", $$v)
      },
      expression: "lemonPostInsightSubmittingData.lemonLink"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.lemonFullname) ? _c('v-text-field', {
    attrs: {
      "label": "Full name"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.lemonFullname),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "lemonFullname", $$v)
      },
      expression: "lemonPostInsightSubmittingData.lemonFullname"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.lemonPostInsightSubmittingData.lemonFollowers) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.lemonFollowers),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "lemonFollowers", $$v)
      },
      expression: "lemonPostInsightSubmittingData.lemonFollowers"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.lemonPostInsightSubmittingData.live_date = _vm.parseDate(_vm.lemonPostInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedLemonDateFormatted),
            callback: function($$v) {
              _vm.computedLemonDateFormatted = $$v
            },
            expression: "computedLemonDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.lemonLiveCal),
      callback: function($$v) {
        _vm.lemonLiveCal = $$v
      },
      expression: "lemonLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.lemonLiveCal = false
      }
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData, "live_date", $$v)
      },
      expression: "lemonPostInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.watches),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "watches", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.watches"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.like_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "bookmarks", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.bookmarks"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.lemonPostInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.lemonPostInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "lemonPostInsightSubmittingData.insights.shares"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.lemonPostInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isFacebook) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.fbPostInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Post Media URL"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData, "media_url", $$v)
      },
      expression: "fbPostInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Post Media URL"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData, "embed_url", $$v)
      },
      expression: "fbPostInsightSubmittingData.embed_url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.fbPostInsightSubmittingData.live_date = _vm.parseDate(_vm.fbPostInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedFacebookDateFormatted),
            callback: function($$v) {
              _vm.computedFacebookDateFormatted = $$v
            },
            expression: "computedFacebookDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.fbLiveCal),
      callback: function($$v) {
        _vm.fbLiveCal = $$v
      },
      expression: "fbLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.fbLiveCal = false
      }
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData, "live_date", $$v)
      },
      expression: "fbPostInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.outreach),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "outreach", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.outreach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.comment_count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bookmarks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.fbPostInsightSubmittingData.insights.bookmarks),
      callback: function($$v) {
        _vm.$set(_vm.fbPostInsightSubmittingData.insights, "bookmarks", _vm._n($$v))
      },
      expression: "fbPostInsightSubmittingData.insights.bookmarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.fbPostInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : (_vm.isLinkedIn || _vm.isTwitter || _vm.isOthers) ? _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.postURL) ? _c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "postURL", $$v)
      },
      expression: "otherInsightSubmittingData.postURL"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isLinkedIn && !_vm.isTwitter) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.media_url) ? _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.media_url),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "media_url", $$v)
      },
      expression: "otherInsightSubmittingData.media_url"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": "Media URL"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.embed_url),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "embed_url", $$v)
      },
      expression: "otherInsightSubmittingData.embed_url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLinkedIn && !_vm.isTwitter) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.othersFullname) ? _c('v-text-field', {
    attrs: {
      "label": "Full name"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.othersFullname),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "othersFullname", $$v)
      },
      expression: "otherInsightSubmittingData.othersFullname"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLinkedIn && !_vm.isTwitter) ? _c('v-row', [(!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [(_vm.otherInsightSubmittingData.othersFollowers) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Followers"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.othersFollowers),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "othersFollowers", $$v)
      },
      expression: "otherInsightSubmittingData.othersFollowers"
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.otherInsightSubmittingData.live_date = _vm.parseDate(_vm.otherInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedOthersDateFormatted),
            callback: function($$v) {
              _vm.computedOthersDateFormatted = $$v
            },
            expression: "computedOthersDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.otherLiveCal),
      callback: function($$v) {
        _vm.otherLiveCal = $$v
      },
      expression: "otherLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.otherLiveCal = false
      }
    },
    model: {
      value: (_vm.otherInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData, "live_date", $$v)
      },
      expression: "otherInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.isLinkedIn) ? _c('v-row', [(!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Total Play Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "hour", $$v)
      },
      expression: "otherTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "minute", $$v)
      },
      expression: "otherTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "md4": "",
      "lg4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.otherTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.otherTotalPlayTime, "second", $$v)
      },
      expression: "otherTotalPlayTime.second"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "views", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.views"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isTwitter) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.watches),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "watches", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.watches"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isTwitter) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "impressions", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Replies",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bookmarks",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "saved", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.saved"
    }
  })], 1)], 1) : (_vm.isLinkedIn) ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Discovery")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "impressions", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Members reached",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.reach),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "reach", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Video Performance")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Video views",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.video_views),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "video_views", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.video_views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold mb-2"
  }, [_vm._v("Profile Activity")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Profile viewers from this post",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.profile_viewers),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "profile_viewers", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.profile_viewers"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 font-weight-bold"
  }, [_vm._v("Engagement")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reactions",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "saved", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.saved"
    }
  })], 1)], 1) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.saved),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "saved", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "comment_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.shares),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "shares", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.otherInsightSubmittingData.insights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.otherInsightSubmittingData.insights, "like_count", _vm._n($$v))
      },
      expression: "otherInsightSubmittingData.insights.like_count"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.otherInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1) : _c('div', {
    staticClass: "ims-modal-body update-insights-body"
  }, [_c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post URL"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post Image URL",
      "placeholder": "Optional"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postImageURL),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "postImageURL", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "postInsightSubmittingData.postImageURL"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-menu', {
    ref: "datePicker",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "mt-3",
          attrs: {
            "append-icon": "event",
            "readonly": "",
            "outlined": ""
          },
          on: {
            "blur": function($event) {
              _vm.postInsightSubmittingData.live_date = _vm.parseDate(_vm.postInsightSubmittingData.live_date)
            }
          },
          model: {
            value: (_vm.computedPostDateFormatted),
            callback: function($$v) {
              _vm.computedPostDateFormatted = $$v
            },
            expression: "computedPostDateFormatted"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.postLiveCal),
      callback: function($$v) {
        _vm.postLiveCal = $$v
      },
      expression: "postLiveCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "input": function($event) {
        _vm.postLiveCal = false
      }
    },
    model: {
      value: (_vm.postInsightSubmittingData.live_date),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData, "live_date", $$v)
      },
      expression: "postInsightSubmittingData.live_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("Post Insights")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "xs": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.openUploadStatsDialog(_vm.isReel ? 'reel' : 'post')
      }
    }
  }, [_vm._v("\n              Upload Stats with AI\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "secondary",
      "disabled": _vm.isLoading || !_vm.getScrapeTargetLink()
    },
    on: {
      "click": function($event) {
        _vm.scrapComments(_vm.getScrapeTargetLink(), _vm.postInsightReportID)
      }
    }
  }, [_vm._v("\n              Extract Stats\n              "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), (!_vm.isReel) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts Reached",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Impressions",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.impressions),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "impressions", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.impressions"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.saved"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isReel) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Accounts Reached",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reach),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reach", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reach"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Plays (Views)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.views),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "views", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.views"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Likes",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.like_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "like_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.like_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Saves (Bookmarks)",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.saved),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "saved", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.saved"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Shares",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.shares),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "shares", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.shares"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reposts",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.reposts),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "reposts", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.inputtedInsights.reposts"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Comments",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.postInsights.comment_count),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.postInsights, "comment_count", _vm._n($$v))
      },
      expression: "postInsightSubmittingData.postInsights.comment_count"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "margin-top": "-3px!important",
      "margin-bottom": "-45px!important"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "rgba(0, 0, 0, 0.6)"
    }
  }, [_vm._v("Watch Time")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "d",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.day),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "day", $$v)
      },
      expression: "reelTotalPlayTime.day"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "h",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.hour),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "hour", $$v)
      },
      expression: "reelTotalPlayTime.hour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "m",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.minute),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "minute", $$v)
      },
      expression: "reelTotalPlayTime.minute"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "s",
      "required": "",
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.reelTotalPlayTime.second),
      callback: function($$v) {
        _vm.$set(_vm.reelTotalPlayTime, "second", $$v)
      },
      expression: "reelTotalPlayTime.second"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Average Watch Time",
      "required": "",
      "type": "number"
    },
    model: {
      value: (_vm.postInsightSubmittingData.inputtedInsights.watches),
      callback: function($$v) {
        _vm.$set(_vm.postInsightSubmittingData.inputtedInsights, "watches", $$v)
      },
      expression: "postInsightSubmittingData.inputtedInsights.watches"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveInputtedInsights(_vm.postInsightSubmittingData)
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('upload-stats-modal', {
    attrs: {
      "value": _vm.uploadStatsDialog,
      "postType": _vm.aiPostType,
      "imagesToView": _vm.imagesToView
    },
    on: {
      "statsConfirmed": _vm.confirmedStats
    },
    model: {
      value: (_vm.uploadStatsDialog),
      callback: function($$v) {
        _vm.uploadStatsDialog = $$v
      },
      expression: "uploadStatsDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72ededd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/UpdateInsightsModal.vue
// module id = 2193
// module chunks = 0